/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingRequest { 
    startDate: string;
    appointmentResourceId: number;
    consentGiven?: boolean;
}
export const BookingRequest_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingRequest_appointmentResourceId_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingRequest_consentGiven_Validators: ValidatorFn[] =
    [ ];


